import { ImagePlaceholder } from '@/components/ImagePlaceholder';
import { Loader } from '@/components/Loader';
import type { Maybe } from '@/lib/types';
import * as S from '@/views/StrapView/components/AddToBagDrawer/AddToBagDrawer.styles';

export interface StrapImageWrapperProps {
  alt: string;
  imageUrl: Maybe<string>;
  loading: boolean;
}
export const StrapImageWrapper = ({
  alt,
  imageUrl,
  loading,
}: StrapImageWrapperProps) => {
  if (loading) {
    return <Loader height={88} />;
  }
  return imageUrl ? (
    <S.ProductImage
      alt={alt}
      fill='true'
      productType='strap'
      src={imageUrl ?? ''}
    />
  ) : (
    <ImagePlaceholder productType='strap' />
  );
};
